import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from 'src/shared/lib/useQuery';
import { getApiUrl } from 'src/shared/lib/getApiUrl';
import { QueryResult } from 'src/shared/types/util.types';

export interface LinkAccountCheckResult {
  needsLinking: boolean;
  primaryUserId: string | null;
}

export function useLinkAccountCheck(): QueryResult<LinkAccountCheckResult> {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: ['link-account-check'],
    queryFn: getData,
    enabled: isAuthenticated,
    staleTime: 10 * 60 * 1000, // 10 minutes - longer cache since it's background only
    retry: 0, // No retries since this is purely background/informational
    refetchOnWindowFocus: false, // Don't refetch on focus since it's background
  });

  async function getData(): Promise<LinkAccountCheckResult> {
    try {
      const token = await getAccessTokenSilently();
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${token}`,
      };
      const url = new URL(getApiUrl() + '/api/v2/account/link-account');

      const res = await fetch(`${url.toString()}`, {
        headers,
      });

      const data = await res.json();

      if (!res.ok) {
        console.warn('Failed to check link account status', data);
        // Return default values for non-blocking behavior
        return { needsLinking: false, primaryUserId: null };
      }

      return data;
    } catch (error) {
      console.warn('Failed to check link account status', error);
      // Return default values for non-blocking behavior
      return { needsLinking: false, primaryUserId: null };
    }
  }
}
